/* globals __CLIENT__, IPSTACK_API_KEY */

import { getLocalStorage, setLocalStorage } from '.';
import { location, searches } from './localStorage';

export const getCountryViewport = (countryCode) => {
  if (countryCode && countryCode.toLowerCase() === 'au') {
    return {
      city: 'Australia',
      locationName: 'Australia',
      viewportNorthEastLat: -0.69,
      viewportNorthEastLong: 166.74,
      viewportSouthWestLat: -51.66,
      viewportSouthWestLong: 100.09,
    };
  } else if (countryCode && countryCode.toLowerCase() === 'us') {
    return {
      city: 'USA',
      locationName: 'USA',
      viewportNorthEastLat: 49.38,
      viewportNorthEastLong: -66.94,
      viewportSouthWestLat: 25.82,
      viewportSouthWestLong: -124.39,
    };
  } else if (countryCode && countryCode.toLowerCase() === 'gb') {
    return {
      city: 'GB',
      locationName: 'United Kingdom',
      viewportNorthEastLat: 49.3836,
      viewportNorthEastLong: -8.593005,
      viewportSouthWestLat: 60.889515,
      viewportSouthWestLong: 1.642589,
    };
  }
  return undefined;
};

export const getGeoLocation = async () => {
  if (__CLIENT__) {
    const lastSearch = JSON.parse(getLocalStorage(searches.last.key));
    if (lastSearch) {
      return lastSearch.locationLat && lastSearch.locationLong
        ? {
          city: lastSearch.locationName,
          latitude: lastSearch.locationLat,
          longitude: lastSearch.locationLong,
        } : {
          city: lastSearch.locationName,
          viewportNorthEastLat: lastSearch.viewportNorthEastLat,
          viewportNorthEastLong: lastSearch.viewportNorthEastLong,
          viewportSouthWestLat: lastSearch.viewportSouthWestLat,
          viewportSouthWestLong: lastSearch.viewportSouthWestLong,
        };
    }
    const recentLocation = JSON.parse(getLocalStorage(location.last.key));
    if (recentLocation && (new Date(recentLocation.expiresAt) > new Date())) {
      return recentLocation.location;
    }
    try {
      let result = await fetch(`https://api.ipstack.com/check?access_key=${IPSTACK_API_KEY}`, { timeout: 500 });
      if (result) {
        result = await result.json();
        if (result.city && result.latitude && result.longitude) {
          const currentLocation = {
            city: result.city,
            latitude: (result.latitude).toString(),
            longitude: (result.longitude).toString(),
          };
          setLocalStorage(location.last.key, JSON.stringify({
            expiresAt: (Date.now() + (12 * 60 * 60 * 1000)),
            location: currentLocation,
          }));
          return currentLocation;
        }
      }
    } catch (e) {
      // do nothing
    }
  }
  return {};
};

export const getLocalQuery = (query, geoLocation = {}) => ({
  ...query,
  ...(geoLocation.city &&
    (geoLocation.latitude
      ? {
        locationName: geoLocation.city,
        locationLat: geoLocation.latitude,
        locationLong: geoLocation.longitude,
        locationSearchRadius: geoLocation.locationSearchRadius || 100,
      } : {
        city: geoLocation.locationName,
        viewportNorthEastLat: geoLocation.viewportNorthEastLat,
        viewportNorthEastLong: geoLocation.viewportNorthEastLong,
        viewportSouthWestLat: geoLocation.viewportSouthWestLat,
        viewportSouthWestLong: geoLocation.viewportSouthWestLong,
      }
    )
  ),
});



// WEBPACK FOOTER //
// ./app/src/utils/geoLocation.js